import { Injectable } from '@angular/core';
/**
 * Encapsulate string utils methods.
 */
var StringUtils = (function () {
    function StringUtils() {
    }
    /**
     * Get from text, the line number (indexLine), null if it does not exists.
     * @param text
     * @param indexLine
     * @returns {string}
     */
    StringUtils.prototype.getLine = function (text, indexLine) {
        var line = null;
        if (text) {
            var lines = text.split('\n');
            line = lines && lines.length > indexLine ? lines[indexLine] : null;
        }
        return line;
    }; // getLine.
    /**
     * Get an string and return it camelcased, ex: "Hello World" > "helloWorld"
     * @param str
     * @returns {string}
     */
    StringUtils.prototype.camelize = function (str) {
        return str
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
            return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
        })
            .replace(/\s+/g, '');
    };
    /**
     * Return a string with the first char in uppercase
     *
     * @param {string} str
     * @returns {string}
     *
     * @memberof StringUtils
     */
    StringUtils.prototype.titleCase = function (str) {
        return "" + str.charAt(0).toLocaleUpperCase() + str.slice(1);
    };
    return StringUtils;
}()); // E:O:F:StringUtils.
export { StringUtils };
StringUtils.decorators = [
    { type: Injectable },
];
/** @nocollapse */
StringUtils.ctorParameters = function () { return []; };
//# sourceMappingURL=string-utils.service.js.map